import script from "./BaseSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSearch.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSearch.vue?vue&type=style&index=0&id=6775b0a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6775b0a6"]])

export default __exports__